<template>
  <v-col
    class="add-row"
    :style="{ justifyContent: justify, height }"
    @click="click"
  >
    <div
      class="add-btn"
      :style="{ background }"
    >
    <v-icon
      class="add-button pr-1"
      :color="color"
      :size="size"
      :class="iconClass"
      light
    >
      {{icon}}
    </v-icon>

    <span :style="`color:${color}`" :class="`add-label ${dark ? 'white--text' : ''}`">{{ label }}</span>

    </div>
  </v-col>
</template>

<script>
export default {
  name: 'AddButton',
  props: {
    label: String,
    justify: { type: String, default: 'center' },
    row: { type: Boolean, default: false },
    height: { type: String },
    size: { type: String, default: '20px' },
    icon: { type: String, default: 'mdi-plus' },
    iconClass: String,
    dark: { type: Boolean, default: false },
    color: { type: String, default: '' },
    background: { type: String, default: '' }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

  <style scoped lang="scss">
    .add-row {
      display: flex;
      align-items: center;
      justify-items: start;
      cursor: pointer;
      padding: 0px;

      .add-btn {
         padding: 6px 14px 6px 8px;
         border-radius: 100px;

        .add-label {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  </style>
